import { getAllComments, deleteComment } from '../services/napi';
import { COMMENTS_FETCH_SUCCESS } from '../constant/actionType';

export function fetchAllComments() {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;
    const response = await getAllComments(projectId);
    dispatch({ data: response.data.comments, type: COMMENTS_FETCH_SUCCESS });
  };
}

export function removeComment(projectId, commentId, onSuccess) {
  return async () => {
    await deleteComment(projectId, commentId);
    onSuccess();
  };
}
